/**
 * Bearer token for calculator API calls. Prefer API access token; fall back
 * to ID token (portal pattern) when silent refresh fails.
 */
export async function getApiBearerToken({ getAccessTokenSilently, getIdTokenClaims, audience }) {
  const authorizationParams = {
    scope: 'openid profile email',
    ...(audience ? { audience } : {}),
  };

  try {
    const accessToken = await getAccessTokenSilently({ authorizationParams });
    if (accessToken) return accessToken;
  } catch {
    // Fall through to ID token.
  }

  const idClaims = await getIdTokenClaims();
  const idRaw = idClaims && typeof idClaims.__raw === 'string' ? idClaims.__raw : '';
  if (idRaw) return idRaw;

  throw new Error('no_bearer_token');
}
